import { useEffect } from "react";
import { DURATION, notify, TYPE } from "@8x8/oxygen-toaster";
import get from "lodash/get";

export const getMessageFromError = (error) =>
  get(error, "data.message") ||
  get(error, "data.error") ||
  error.message ||
  error.error;

export const errorNotification = (error, customExtractor = null) => {
  const options = {
    type: TYPE.error,
    content: (customExtractor ?? getMessageFromError)(error),
    duration: DURATION.INFINITE,
  };
  notify(options);
};

export function useErrorNotification(error) {
  useEffect(() => {
    if (!error) {
      return;
    }

    errorNotification(error);
  }, [error]);
}
